import React from 'react';
import classNames from 'classnames';

/**
 * The `<SummaryStatsContainer>` handles the rendering of the container for
 * "summary" stats data.
 */
export default function SummaryStatsContainer({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={classNames(
        'flex flex-col rounded-lg border border-grey-300 p-4',
        className,
      )}
    >
      {children}
    </div>
  );
}
